<ng-template>
  <div [@fadeIn] class="error">
    <ng-content></ng-content>
  </div>
</ng-template>
